/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import { Container } from '@mantine/core'
import InterventionListCard, { InterventionListQuery } from '../intervention/InterventionListCard'
import { getInterventionCreateLink } from '../../lib/links/interventionLinks'
import Page from '../../../../client/js/components/Page'
import { useRouteLoaderData } from '../../../../client/js/components/RouteLoaderData'
import EstateBreadcrumb from './EstateBreadcrumb'

function EstateInterventionListPage () {
  const intl = useIntl()
  const params = useParams<{ id: string }>()
  const estateId = parseInt(params.id, 10)
  const estate = useRouteLoaderData<Estate>()

  const [searchParams, setSearchParams] = useQueryParams()
  const searchQuery: InterventionListQuery = useMemo(() => ({
    ...searchParams,
    estateId: params.id
  }), [params.id, searchParams])

  const title = intl.formatMessage({
    id: 'interventions',
    defaultMessage: 'Interventions'
  })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <EstateBreadcrumb
          estate={estate}
          title={title}
        />

        <InterventionListCard
          createLink={getInterventionCreateLink({ estateId })}
          query={searchQuery}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default EstateInterventionListPage
